/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Brave_Talk_Link_TextInputs */

const en_brave_talk_link_text = /** @type {(inputs: Brave_Talk_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Get quick answers about Brave Talk`)
};

const id_brave_talk_link_text = /** @type {(inputs: Brave_Talk_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dapatkan jawaban cepat tentang Brave Talk`)
};

const ms_brave_talk_link_text = /** @type {(inputs: Brave_Talk_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dapatkan jawapan pantas tentang Brave Talk`)
};

const ca_brave_talk_link_text = /** @type {(inputs: Brave_Talk_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obtingues respostes ràpides sobre Conversa de Brave`)
};

const cs_brave_talk_link_text = /** @type {(inputs: Brave_Talk_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Získejte rychlé odpovědi o Brave Talk`)
};

const da_brave_talk_link_text = /** @type {(inputs: Brave_Talk_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Få hurtige svar om Brave Videoopkald`)
};

const de_brave_talk_link_text = /** @type {(inputs: Brave_Talk_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erhalten Sie schnelle Antworten zu Brave Talk.`)
};

const et_brave_talk_link_text = /** @type {(inputs: Brave_Talk_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saa kiireid vastuseid Brave'i suhtluse kohta`)
};

const es_brave_talk_link_text = /** @type {(inputs: Brave_Talk_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obtén respuestas rápidas acerca de Brave Talk`)
};

const fr_brave_talk_link_text = /** @type {(inputs: Brave_Talk_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obtenir de l’aide concernant Appels Brave`)
};

const hr_brave_talk_link_text = /** @type {(inputs: Brave_Talk_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dobite brze odgovore o usluzi Brave Talk`)
};

const it_brave_talk_link_text = /** @type {(inputs: Brave_Talk_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ricevi risposte rapide su Videoconferenze Brave`)
};

const lv_brave_talk_link_text = /** @type {(inputs: Brave_Talk_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saņemiet ātras atbildes par Brave Talk`)
};

const lt_brave_talk_link_text = /** @type {(inputs: Brave_Talk_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gaukite greitus atsakymus apie „Brave Talk“`)
};

const hu_brave_talk_link_text = /** @type {(inputs: Brave_Talk_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gyors válaszok a Brave Talkról`)
};

const nl_brave_talk_link_text = /** @type {(inputs: Brave_Talk_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Krijg meer informatie over Brave Talk`)
};

const nb_brave_talk_link_text = /** @type {(inputs: Brave_Talk_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Få kjappe svar om Brave Talk`)
};

const pl_brave_talk_link_text = /** @type {(inputs: Brave_Talk_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uzyskaj szybkie odpowiedzi na temat Brave Talk`)
};

const pt_brave_talk_link_text = /** @type {(inputs: Brave_Talk_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obtenha respostas rápidas sobre o Brave Talk`)
};

const ro_brave_talk_link_text = /** @type {(inputs: Brave_Talk_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obține răspunsuri rapide despre Brave Talk`)
};

const sk_brave_talk_link_text = /** @type {(inputs: Brave_Talk_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Získajte rýchle odpovede o Brave Talk`)
};

const sl_brave_talk_link_text = /** @type {(inputs: Brave_Talk_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pridobite hitre odgovore o storitvi Brave Pogovor`)
};

const fi_brave_talk_link_text = /** @type {(inputs: Brave_Talk_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hanki nopeasti vastauksia Brave Talkista`)
};

const sv_brave_talk_link_text = /** @type {(inputs: Brave_Talk_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Få snabba svar om Brave Samtal`)
};

const vi_brave_talk_link_text = /** @type {(inputs: Brave_Talk_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tham khảo câu trả lời nhanh về Brave Trò chuyện`)
};

const tr_brave_talk_link_text = /** @type {(inputs: Brave_Talk_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave Talk hakkında hızlı yanıtlar alın`)
};

const el_brave_talk_link_text = /** @type {(inputs: Brave_Talk_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Λάβετε γρήγορες απαντήσεις για το Brave Talk`)
};

const bg_brave_talk_link_text = /** @type {(inputs: Brave_Talk_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Получи бързи отговори за Brave Talk`)
};

const ru_brave_talk_link_text = /** @type {(inputs: Brave_Talk_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Получите быстрые ответы о Brave Talk`)
};

const sr_brave_talk_link_text = /** @type {(inputs: Brave_Talk_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Кратки одговори на питања о Brave Talk-у`)
};

const uk_brave_talk_link_text = /** @type {(inputs: Brave_Talk_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отримайте швидкі відповіді про Brave Talk`)
};

const ka_brave_talk_link_text = /** @type {(inputs: Brave_Talk_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`მიიღეთ სწრაფი პასუხები Brave Talk-ის შესახებ`)
};

const hi_brave_talk_link_text = /** @type {(inputs: Brave_Talk_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ब्रेव टॉक के बारे में जानकारी पाएं`)
};

const th_brave_talk_link_text = /** @type {(inputs: Brave_Talk_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`รับคำตอบอย่างรวดเร็วเกี่ยวกับ Brave Talk`)
};

const ko_brave_talk_link_text = /** @type {(inputs: Brave_Talk_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave Talk에 관한 자주 묻는 질문`)
};

const zh_brave_talk_link_text = /** @type {(inputs: Brave_Talk_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`获取有关 Brave Talk 的快速解答`)
};

const zh_tw_brave_talk_link_text = /** @type {(inputs: Brave_Talk_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`獲取有關 Brave 視訊通話的快速解答`)
};

const ja_brave_talk_link_text = /** @type {(inputs: Brave_Talk_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave Talkに関するクイックアンサー`)
};

/**
* | output |
* | --- |
* | "Get quick answers about Brave Talk" |
*
* @param {Brave_Talk_Link_TextInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const brave_talk_link_text = /** @type {((inputs?: Brave_Talk_Link_TextInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Brave_Talk_Link_TextInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_brave_talk_link_text(inputs)
	if (locale === "ms") return ms_brave_talk_link_text(inputs)
	if (locale === "ca") return ca_brave_talk_link_text(inputs)
	if (locale === "cs") return cs_brave_talk_link_text(inputs)
	if (locale === "da") return da_brave_talk_link_text(inputs)
	if (locale === "de") return de_brave_talk_link_text(inputs)
	if (locale === "et") return et_brave_talk_link_text(inputs)
	if (locale === "es") return es_brave_talk_link_text(inputs)
	if (locale === "fr") return fr_brave_talk_link_text(inputs)
	if (locale === "hr") return hr_brave_talk_link_text(inputs)
	if (locale === "it") return it_brave_talk_link_text(inputs)
	if (locale === "lv") return lv_brave_talk_link_text(inputs)
	if (locale === "lt") return lt_brave_talk_link_text(inputs)
	if (locale === "hu") return hu_brave_talk_link_text(inputs)
	if (locale === "nl") return nl_brave_talk_link_text(inputs)
	if (locale === "nb") return nb_brave_talk_link_text(inputs)
	if (locale === "pl") return pl_brave_talk_link_text(inputs)
	if (locale === "pt") return pt_brave_talk_link_text(inputs)
	if (locale === "ro") return ro_brave_talk_link_text(inputs)
	if (locale === "sk") return sk_brave_talk_link_text(inputs)
	if (locale === "sl") return sl_brave_talk_link_text(inputs)
	if (locale === "fi") return fi_brave_talk_link_text(inputs)
	if (locale === "sv") return sv_brave_talk_link_text(inputs)
	if (locale === "vi") return vi_brave_talk_link_text(inputs)
	if (locale === "tr") return tr_brave_talk_link_text(inputs)
	if (locale === "el") return el_brave_talk_link_text(inputs)
	if (locale === "bg") return bg_brave_talk_link_text(inputs)
	if (locale === "ru") return ru_brave_talk_link_text(inputs)
	if (locale === "sr") return sr_brave_talk_link_text(inputs)
	if (locale === "uk") return uk_brave_talk_link_text(inputs)
	if (locale === "ka") return ka_brave_talk_link_text(inputs)
	if (locale === "hi") return hi_brave_talk_link_text(inputs)
	if (locale === "th") return th_brave_talk_link_text(inputs)
	if (locale === "ko") return ko_brave_talk_link_text(inputs)
	if (locale === "zh") return zh_brave_talk_link_text(inputs)
	if (locale === "zh-tw") return zh_tw_brave_talk_link_text(inputs)
	if (locale === "ja") return ja_brave_talk_link_text(inputs)
	return en_brave_talk_link_text(inputs)
});